import React, { useState, useEffect, useContext } from 'react'
import { appContext } from '../../../../../../App'
import UsersAccounts from './UsersAccounts'
import { getClientUsers, saveClientUser, deleteClientUser } from '../../NPOSAccountFunctions'

export const usersAccountsControllerContext = React.createContext()

function useUsersAccountsController(props) {
  const initUser = {
    first_name: '',
    middle_name: '',
    last_name: '',
    designation: '',
    login_details: {
      user_name: '',
      password: '',
      confirm_password: '',
      new_password: '',
      confirm_new_password: ''
    },
    user_access: {
      dashboard: false,

      products: false,
      products_fc: false,

      stockin: false,
      stockin_fc: false,

      stockout: false,
      stockout_fc: false,

      invoice: false,
      invoice_fc: false,

      customers_accounts: false,
      customers_accounts_fc: false,

      receipts: false,
      receipts_fc: false,

      reports: false,
      reports_sales_reports: false,
      reports_sales_reports_daily_sales: false,
      reports_sales_reports_monthly_sales: false,
      reports_sales_reports_yearly_sales: false,
      reports_sales_reports_receivables: false,
      reports_inventory_reports: false,
      reports_inventory_reports_products_inventory: false,
      reports_inventory_reports_out_of_stocks: false,
      reports_inventory_reports_price_list: false,
      reports_inventory_reports_products_sold: false,
      reports_inventory_reports_unmoving_products: false,
      reports_inventory_reports_products_with_exprations: false,

      utilities: false,
      utilities_purchase_order: false,
      utilities_percent_off_batch_set: false,
      utilities_reset_percent_off: false,

      settings: false,
      settings_warehouses: false,
      settings_vat: false,
      settings_npos_accounts_settings: false,

      help: false
    }
  }
  const app = useContext(appContext)
  const { resetClient } = app
  const [user, setUser] = useState(initUser)
  const [users, setUsers] = useState([])

  const resetUser = () => { setUser(initUser) }
  
  const init = async () => {
    const client_users = await getClientUsers(app)
    setUsers(client_users)
  }

  const reloadUserAccounts = async (client) => {
    // Reset user
    setUser(initUser)
    // Set the updated Client collection
    await resetClient(client)
    // Reload users
    await init() 
  }

  const updateClientUser = async (mode, user_id) => {
    let updated_client = null
    if (mode === 'save') {
      updated_client = await saveClientUser(app, user)
      if (!updated_client?.error) await reloadUserAccounts(updated_client)
    } else if (mode === 'delete') {
      updated_client = await deleteClientUser(app, user_id)
      await reloadUserAccounts(updated_client)
    }
    return updated_client
  }

  useEffect(() => {
    init() 
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return ({
    user: [user, setUser],
    users,
    resetUser,
    updateClientUser
  })
}

function UsersAccountsController(props) {
  const usersAccountsController = useUsersAccountsController(props)
  return (
    <React.Fragment>
      <usersAccountsControllerContext.Provider value={usersAccountsController}>
        <UsersAccounts />
      </usersAccountsControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(UsersAccountsController)